<!--
  --
  -- アカウント情報のサマリ コンポーネント
  --
  -->
<template>
  <c-summary-sheet>
    <template #title>ログインアカウント</template>

    <template>
      <!-- メールアドレス -->
      <c-summary-item>
        <template #caption>Eメール</template>
        <template #value>{{account.email}}</template>
      </c-summary-item>
    </template>
  </c-summary-sheet>
</template>

<script>
import CSummarySheet from './CSummarySheet'
import CSummaryItem from './CSummaryItem'

export default {
  name: 'CSummaryAccount',
  components: {
    CSummarySheet,
    CSummaryItem
  },

  props: {
    account: {
      type: Object,
      required: true
    }
  }
}
</script>
